<script setup>
import { defineProps, defineModel, computed, watch } from 'vue';
import { useSwitcher } from '@/composables/useSwitcher';

const item = defineModel();

const props = defineProps({
  level: {
    type: Number,
    default: 1
  }
});

const toggleClick = () => {
  if (Object.hasOwn(item.value, 'childItems') && item.value.childItems.length)
    item.value.expand = !item.value.expand;
  else item.value.isSelect = !item.value.isSelect;
};

const styleChild = () => {
  if (props.level === 2) {
    return { 'padding-left': props.level * 20 + 'px' };
  }
  if (props.level > 2) {
    return { 'padding-left': props.level * 18.65 + 'px' };
  }
};

const toggleSelect = (item) => {
  item.isSelect = !item.isSelect;
};
</script>

<template>
  <div
    v-if="item.childItems"
    @click.stop="toggleClick()"
    class="accordion-list-item__main"
    :style="styleChild()"
    :class="{ 'is-showing': item.expand }"
  >
    <div class="item-title-sec ellipsis">
      <img v-if="item.icon && level === 1" :src="item.icon" alt="" />
      {{ item.text }}&nbsp;
      <span v-if="level === 1">({{ item.childItems.length }})</span>
    </div>

    <lego-icon
      class="lego-dropdown__icon expand-icon"
      icon-type="df"
      icon="arrow_down"
      size="16px"
    />
  </div>
  <div
    class="accordion-list-item__main"
    :style="styleChild()"
    v-else
    :class="{ 'lego-dropdown__checked': item.isSelect }"
    @click="toggleSelect(item)"
  >
    <lego-checkbox v-model="item.isSelect">
      <div v-lego-tooltip:ellipsis="item.text">
        {{ item.text }}
      </div>
    </lego-checkbox>
  </div>

  <div v-if="item.childItems && item.expand">
    <tree-checkbox-dropdown-item
      v-for="(child, i) in item.childItems"
      :key="child.value"
      v-model="item.childItems[i]"
      :level="level + 1"
    />
  </div>
</template>

<style scoped lang="scss">
.accordion-list-item {
  background-color: $color--ui-white;

  &__main {
    height: 36px;
    display: flex;
    align-items: center;
    padding-right: 12px;
    padding-left: 12px;
    cursor: pointer;

    &:hover {
      background-color: #eff1fb !important;
    }

    &.is-showing {
      .expand-icon {
        transform: rotate(-180deg);
      }
    }
    &.lego-dropdown__checked {
      background-color: #eff1fb !important;
    }

    .lego-checkbox,
    .lego-radio {
      flex: none;
      margin-right: 8px;

      &:hover {
        & + .item-title-sec {
          color: inherit;

          :deep & + .expand-icon {
            .lego-icon {
              color: rgba($color--ui01, 0.6);
            }
          }
        }
      }
    }

    .item-title-sec {
      flex: 1 1 auto;
      font-weight: 500 !important;
      @include font(14px);
      display: flex;
      img {
        width: 20px;
        height: 20px;
        margin-right: 8px;
      }
    }

    .expand-icon {
      transition: all ease-in-out 0.3s;
    }
    :deep .lego-checkbox__label {
      display: block;
      // width: calc(100% - 10px);
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      color: #2f3237;
      padding-top: 1px;
      width: 100%;
      em {
        display: block;
        font-style: normal;
        @include ellipsis;
      }
    }

    :deep .lego-checkbox {
      display: block;
      flex: 0 1 auto;
      align-items: flex-start;
      padding: 0 0 0 15px;
      width: 100%;
    }

    :deep .lego-checkbox__icon {
      position: absolute;
      top: 3px;
      left: 0;
    }
  }

  &__expand {
    border-top: 1px solid $color--ui08;
    margin: 0 20px;
    padding: 8px 12px;
  }
}
</style>
